<template>
    <popup :close-action="emitCloseEvent" class="apple-promotion-popup" :buttons="buttons">
        <template v-slot:title>
            <img :src="require('@/assets/promotion-present.png')" class="image-in-popup"/>
            <div class="ri-medium-bold-headline margin-top-ml">{{ benefitText }}</div>
        </template>
    </popup>
</template>

<script>
import BenefitMixin from '@/pages/responsive-pages/authenticated/subscription/V2/BenefitMixin.vue';
import BaseUI from '@riseupil/base-ui';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import DDLogs from '@/DDLogs';
import { isIosNativeApp } from '@/utils/deviceUtils';
import MobileMessagesUtils from '@/utils/mobileMessagesUtils';
import BillyApi from '@/api/BillyApi';
import EventBus from '@/event-bus/event-bus';
import router from '@/router';
import ApplePromotionWebPopup from './ApplePromotionWebPopup.vue';
import ApplePromotionNonPayerPopup from './ApplePromotionNonPayerPopup.vue';
import LoaderPopup from '../PayOnWebPopups/LoaderPopup.vue';
import ApplePromotionSuccessPopup from './ApplePromotionSuccessPopup.vue';

export default {
  name: 'ApplePromotionPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  mixins: [
    BenefitMixin,
  ],
  methods: {
    ...mapActions('modalRootStore', ['openModal', 'closeModal', 'closeAllModals']),
    ...mapActions('benefits', ['redeemBenefit']),
    ...mapMutations('benefits', ['setBenefitRedeemed']),
    async redeemBenefitClicked() {
      if (this.isCurrentMemberPaying === true) {
        if (isIosNativeApp()) {
          this.openModal({ component: LoaderPopup });
          try {
            const signature = await BillyApi.getApplePromotionSignature({ offerId: this.promotion });
            MobileMessagesUtils.dispatchMessageToMobile(MobileMessagesUtils.MOBILE_MESSAGES_NAME.APPLY_SUBSCRIPTION_PROMOTION, signature);
          } catch (error) {
            DDLogs.error('Error getting apple promotion signature:', error);
            this.closeAllModals();
            await router.push({ path: '/error' });
          }
        } else {
          this.emitCloseEvent();
          this.openModal({
            component: ApplePromotionWebPopup,
            props: {
              onClose: () => this.closeModal(),
            },
          });
        }
      } else {
        this.emitCloseEvent();
        this.openModal({
          component: ApplePromotionNonPayerPopup,
          props: {
            onClose: () => this.closeModal(),
          },
        });
      }
    },
    async onMobileSubscriptionPromotionResult(message) {
      DDLogs.log('Apple Subscription Promotion:', message);

      if (message.result !== 'success') {
        DDLogs.error('apple subscription promotion result:', message.result);
        this.closeAllModals();
        await router.push({ path: '/error' });
        return;
      }

      try {
        await this.redeemBenefit();
        await this.setBenefitRedeemed(true);
        DDLogs.log('Success redeeming apple promotion');
        this.closeAllModals();
        this.openModal({ component: ApplePromotionSuccessPopup });
      } catch (error) {
        DDLogs.error('Error redeeming Apple promotion:', error);
        this.closeAllModals();
        await router.push({ path: '/error' });
      }
    },
    emitCloseEvent() {
      this.$emit('close');
    },
  },
  computed: {
    ...mapGetters(
      'subscription',
      ['payingMemberId', 'userCanceledSubscription'],
    ),
    ...mapState('session', ['activeMember', 'members']),
    ...mapGetters('benefits', ['promotion']),
    isCurrentMemberPaying() {
      return this.activeMember._id === this.payingMemberId;
    },
    benefitText() {
      return this.applePromotionText;
    },
    buttons() {
      return [{
        title: 'לממש את ההטבה עכשיו',
        action: this.redeemBenefitClicked,
      }];
    },
  },
  created() {
    EventBus.$on('mobileSubscriptionPromotionResult', this.onMobileSubscriptionPromotionResult);
  },
  beforeDestroy() {
    EventBus.$off('mobileSubscriptionPromotionResult', this.onMobileSubscriptionPromotionResult);
  },
};
</script>

<style lang="scss" scoped>

@import '~@riseupil/base-ui/src/scss/riseup-colors';

  .apple-promotion-popup {
    text-align: center;
    .popup{
      padding-bottom: 0;
    }
    .image-in-popup {
      width: 100%;
    }
  }

</style>
